import { parseDate, parseNumber, parseString } from 'utils/parsingHelpers'

export enum ShiftTypes {
  Day = 'day',
  Night = 'night',
  DayAndNight = 'day_and_night',
}

export enum CleaningTypes {
  Gecko = 'gecko',
  Customer = 'customer',
}

export interface ScopeJSON {
  num_shifts?: number
  shift_length?: number
  shift_types?: ShiftTypes
  shift_start_time?: string
  site_address?: string
  company?: string
  pm_notes?: string
  cleaning?: {
    type?: CleaningTypes
    cleaner?: string
    start_date?: Date
    end_date?: Date
  }
  access?: string
  site_contact_email?: string
  site_contact_phone?: string
  site_contact_name?: string
}

export const getShiftType = (value: string) => {
  if (Object.values(ShiftTypes).includes(value as ShiftTypes)) {
    return value as ShiftTypes
  }
  return ShiftTypes.Day
}

export const getCleaningTypes = (value: string) => {
  if (Object.values(CleaningTypes).includes(value as CleaningTypes)) {
    return value as CleaningTypes
  }
  return undefined
}

export const parseScopeJSON = (value: unknown): ScopeJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  const cleaning = data.cleaning as Record<string, unknown> | undefined
  return {
    num_shifts: parseNumber(data.num_shifts),
    shift_length: parseNumber(data.shift_length),
    shift_types: getShiftType(parseString(data.shift_types) ?? ''),
    shift_start_time: parseString(data.shift_start_time),
    site_address: parseString(data.site_address),
    company: parseString(data.company),
    pm_notes: parseString(data.pm_notes),
    cleaning: cleaning
      ? {
          type: getCleaningTypes(parseString(cleaning.type) ?? ''),
          cleaner: parseString(cleaning.cleaner),
          start_date: parseDate(cleaning.start_date),
          end_date: parseDate(cleaning.end_date),
        }
      : undefined,
    access: parseString(data.access),
    site_contact_email: parseString(data.site_contact_email),
    site_contact_phone: parseString(data.site_contact_phone),
    site_contact_name: parseString(data.site_contact_name),
  }
}
